import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { ClientInstructionService } from 'src/app/service/client-instruction.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: "app-instruction-poup-box",
  templateUrl: "./instruction-poup-box.component.html",
  styleUrls: ["./instruction-poup-box.component.css"],
})
export class InstructionPoupBoxComponent implements OnInit,AfterViewInit {
  DisableAll = false;
  canEdit: boolean = true;
  @Output() Toggle = new EventEmitter<any>();
  InstructionScenario = "scenario";
  InstructionAction = "action";
  @Input() disabledInstruction;
  @Input() getClientID;
  ResponseHelper: ResponseHelper;
  Instructions_Action = "";
  Instructions_Scenario = "";
  instruction = {};
  dataload = false;
  constructor(
    private instructionservice: ClientInstructionService,
    private notificationservice: NotificationService
  ) {}

  ngOnInit() {
    // console.log(this.instruction, "instruction");

    this.ResponseHelper = new ResponseHelper(this.notificationservice);
    if (this.getClientID[2] != "insert") {
      // console.log(this.getClientID, "getClientID");
      if (this.getClientID.length)
        this.instructionservice
          .getSupervisorClientInstructionInformation(
            this.getClientID[3],
            this.getClientID[0].Id
          )
          .subscribe(
            (res) => {
              this.Instructions_Action = res.Data.Instructions_Action;
              this.Instructions_Scenario = res.Data.Instructions_Scenario;
              this.dataload = true;
              // this.ResponseHelper.GetSuccessResponse(res);
            },
            (err) => {
              this.ResponseHelper.GetFaliureResponse(err);
            }
          );
    } else {
      this.Instructions_Action = this.getClientID[0].Instructions_Action;
      this.Instructions_Scenario = this.getClientID[0].Instructions_Scenario;
      this.dataload = true;
    }
  }

  ngAfterViewInit(){
    var textareaAction = document.getElementById('textareaAction')
    var textareaScenario = document.getElementById('textareaScenario')

    if(textareaAction) {
      textareaAction.addEventListener('keydown', autosize);
      textareaScenario.addEventListener('keydown', autosize);
    }

    function autosize(){
      var el = this;
      if(el.scrollHeight > 370) return
      setTimeout(function(){
        el.style.cssText = 'height:auto;';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';
      },0);
    }
  }


  toggleModel() {
    // console.log(this.disabledInstruction);

    this.Instructions_Action =  this.disabledInstruction ? this.Instructions_Action : this.getClientID[0].Instructions_Action;
    this.Instructions_Scenario = this.disabledInstruction ? this.Instructions_Scenario : this.getClientID[0].Instructions_Scenario;

    this.instruction = {
      Instructions_Scenario: this.Instructions_Scenario,
      Instructions_Action: this.Instructions_Action,
      instruction_update: "insert"
    };
    this.Toggle.emit(this.instruction);
  }

  instructionData() {
    // console.log(this.instruction.Data.Instructions_Scenario, this.instruction.Data.Instructions_Action);
    this.instruction = {
      Instructions_Scenario: ' '+ this.Instructions_Scenario.trim(),
      Instructions_Action: ' '+ this.Instructions_Action.trim(),
      instruction_update: "insert"
    };
    this.Toggle.emit(this.instruction);
  }
}
